import { useMutation, useQueryClient } from '@tanstack/react-query';
import recoveryMessagesService from 'v2/services/recoveryMessages';
import type { RecoveryMessage } from 'v2/services/recoveryMessages';

interface CreateRecoveryMessageParams {
  productId: number;
  data: Omit<RecoveryMessage, 'id'>;
}

export function useCreateRecoveryMessage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ productId, data }: CreateRecoveryMessageParams) => recoveryMessagesService.create(productId, data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['recoveryMessages', variables.productId] });
    }
  });
}
